module.exports = __webpack_public_path__ + "images/banners/item_top/item_top_banner_stores_text_fd629d9a4c8940491af72406264a0a94.png";